import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import DateTimeInput from './DateTimeInput';

const DateInput = ({ name, label, isReadonly, validators, required, horizontal, onChange, ...props }) => {
	return <Field
		name={name}
		disabled={isReadonly}
		component={DateTimeInput}
		required={required}
		horizontal={horizontal}
		showTime={false}
		label={label}
		validate={validators}
		onChange={onChange}
		{...props}
	/>
};

DateInput.propTypes = {	
	label: PropTypes.string,
	name: PropTypes.string
};
export default DateInput;